import type { ComponentPublicInstance } from 'vue';

interface VueErrorInfo {
    // 错误基础信息
    errName?: string;
    errMessage?: string;
    errStack?: string;
    // Vue 上下文
    componentName: string;
    lifecycleHook: string;
    // 原始数据
    rawError: unknown;
}

/** 构建错误信息对象 */
function buildErrorInfo(
    err: unknown,
    instance: ComponentPublicInstance | null,
    lifecycleHook: string,
): VueErrorInfo {
    const base: VueErrorInfo = {
        lifecycleHook,
        componentName:
            instance?.$options.name || instance?.$options.__name || 'Anonymous',
        rawError: err,
    };

    if (err instanceof Error) {
        base.errName = err.name;
        base.errMessage = err.message;
        base.errStack = err.stack;
    }

    return base;
}

/** Vue 全局错误处理器 */
export function vueErrorHandler(
    err: unknown,
    instance: ComponentPublicInstance | null,
    lifecycleHook: string,
): void {
    const errorInfo = buildErrorInfo(err, instance, lifecycleHook);
    console.error('[Vue Error]', errorInfo);
}
